const i = {
  Billing: "BILLING",
  Shipping: "SHIPPING",
  Mailing: "MAILING",
  Tax: "TAX"
};
export {
  i
};
//# sourceMappingURL=ContactType-95758036.mjs.map
